import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { openConfirmationModal, setFormDirty } from '../../reducers/uiSlice';
import { confirmationService } from '../../services/confirmationService';
import { cn } from '../../lib/utils';
import { DashboardIcon, ProjectsIcon, SyncNavIcon, SettingsNavIcon, ChatIcon } from '../Icons/svgIcons';
import { useUnreadCount } from '../../hooks/useUnreadCount';

const Navbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isFormDirty } = useSelector(state => state.ui);
  const unreadCount = useUnreadCount();

  const navigationItems = [
    { name: 'Dashboard', href: '/dashboard', Icon: DashboardIcon },
    { name: 'Forms', href: '/forms', Icon: ProjectsIcon },
    { name: 'Chat', href: '/chat', Icon: ChatIcon },
    { name: 'Sync', href: '/sync', Icon: SyncNavIcon },
    { name: 'Settings', href: '/settings', Icon: SettingsNavIcon }
  ];

  const handleNavigate = (path) => {
    if (location.pathname.startsWith('/forms/fill/') && isFormDirty) {
      const confirmId = `nav-away-${path.replace('/', '')}`;
      confirmationService.register(confirmId, () => {
        dispatch(setFormDirty(false));
        navigate(path);
      });
      dispatch(openConfirmationModal({
        title: 'Discard Changes?',
        message: 'You have unsaved changes. Are you sure you want to leave this page?',
        type: 'destructive',
        confirmId
      }));
    } else {
      navigate(path);
    }
  };

  return (
    <div id="tour-bottom-nav" className="w-full border-t border-gray-200 bg-white">
      <div className="max-w-md mx-auto flex items-center justify-between px-2">
        {navigationItems.map(item => {
          const isActive = location.pathname.startsWith(item.href);
          return (
            <button
              key={item.name}
              onClick={() => handleNavigate(item.href)}
              className="flex-1 flex flex-col items-center justify-center group"
            >
              <div
                className={cn(
                  'flex flex-col items-center gap-1 px-3 py-2 transition-all duration-200',
                  isActive ? 'icon-bg-theme shadow-sm' : 'bg-transparent group-hover:bg-gray-50'
                )}
              >
                <div className="relative">
                  <item.Icon
                    className={cn(
                      "w-6 h-6 transition-colors duration-200",
                      isActive ? "icon-theme" : "text-gray-400 group-hover:text-gray-600"
                    )}
                  />
                  {item.name === 'Chat' && unreadCount > 0 && (
                    <span
                      className={cn(
                        "absolute -top-1.5 -right-2.5 flex items-center justify-center rounded-full bg-red-500 text-[9px] font-bold text-white shadow-sm ring-1 ring-white leading-none",
                        unreadCount > 20 ? "px-1 min-w-[18px] h-4" : "w-4 h-4"
                      )}
                    >
                      {unreadCount > 20 ? '20+' : unreadCount}
                    </span>
                  )}
                </div>
                <span
                  className={cn(
                    'text-[12px] tracking-tight transition-colors duration-200',
                    isActive ? "font-bold icon-theme" : "font-semibold text-gray-400 group-hover:text-gray-600"
                  )}
                >
                  {item.name}
                </span>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default Navbar;